// Engineer-only score-debug badge: per-tile hover card showing the OpenSearch score breakdown.

export interface StockScoreDebugBadgeProps {
  idStockMedia: string;
}

export interface CardPosition {
  top: number;
  left: number;
}

export type StockScoreDebugRow = {kind: 'row'; label: string; value: string; valueClass?: string} | {kind: 'divider'} | {kind: 'title'; text: string};

export const STOCK_SCORE_DEBUG_CARD_WIDTH = 280;
export const STOCK_SCORE_DEBUG_CARD_OFFSET = 4;
export const STOCK_SCORE_DEBUG_DESCRIPTION_MAX = 140;
